/** @format */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import '../css/Results.css';
import Result from './cards/Result';

import results from '../utils/results';
import line from '../images/underline.png';

const Results = () => {
  const bannerTop = useSelector((state) => state.banner.value.banner);
  const mobile = window.innerWidth <= 460;
  const [paddingTop, setPaddingTop] = useState();
  const [resultNumbers, setResultNumbers] = useState(8);

  useEffect(() => {
    if (bannerTop) {
      setPaddingTop(mobile ? 200 : 140);
    } else {
      setPaddingTop(80);
    }
  }, [bannerTop, mobile]);

  return (
    <div
      className="Results"
      id="home"
      style={{ paddingTop: paddingTop }}
    >
      <div className="results-container container">
        <h1>
          RESULTADO DE{' '}
          <span>
            <img
              src={line}
              alt="underline"
              className="results-line"
            />
            ALUMNOS
          </span>
        </h1>
        <div className="results-content">
          {results
            .filter((result) => result.id < resultNumbers)
            .map((result, index) => (
              <Result key={index} result={result} />
            ))}
        </div>
        {resultNumbers >= results.length - 1 ? null : (
          <button
            className="see-more-results"
            onClick={() => {
              setResultNumbers(resultNumbers + 4);
            }}
          >
            VER MÁS
          </button>
        )}
      </div>
    </div>
  );
};

export default Results;
